// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';
import ToggleController from '../../controllers/ToggleController';
import ButtonAction from './ButtonAction';
import ModalAction from './ModaAction';
import InvoiceHistoryModule from '../../modules/invoiceHistory';
import { DesktopView, MobileView } from '../../config/mediaQuery';
import { ActionsContext } from '../../context/actions.context';

type Props = {
  item: GridItem,
};

type State = {};

class InvoiceHistoryAction extends React.Component<
  CommonActionProps & Props,
  State,
> {
  static defaultProps = {
    size: 'xsmall',
  };
  static contextType = ActionsContext;

  render() {
    const { props } = this;
    const { setFullScreenView } = this.context;

    const accountName = props && props.item && props.item.AcctName;

    const invoiceHistory = <InvoiceHistoryModule
      isFullPage={false}
      selectedRow={props.item}
      accountName={accountName}
    />;


    return (
      <ToggleController>
        {({ onToggleVisibility, visible }: any) => (
          <React.Fragment>
            <DesktopView>
              <ButtonAction
                bsSize={props.size}
                disabled={props.disabled}
                onClick={onToggleVisibility}
              >
                <Glyphicon glyph="time" /> Invoice History
              </ButtonAction>
            </DesktopView>
            <MobileView>
              <button disabled={props.disabled} onClick={onToggleVisibility}>
                <img src='assets/history.svg' alt='invoice history icon'/>
                Invoice History
              </button>
            </MobileView>
            <DesktopView>
            <ModalAction show={visible} onHide={onToggleVisibility}>
              {({ showContent }) => (
                <React.Fragment>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      Invoice History -{' '}
                      {accountName}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {visible && (
                      invoiceHistory
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={onToggleVisibility}>Close</Button>
                  </Modal.Footer>
                </React.Fragment>
              )}
            </ModalAction>
            </DesktopView>
            <MobileView>
              {setFullScreenView && setFullScreenView(visible ? invoiceHistory : null, "Invoice History", onToggleVisibility)}  
            </MobileView>
          </React.Fragment>
        )}
      </ToggleController>
    );
  }
}

export default InvoiceHistoryAction;
